export function rulesFor(groupName) {
    // Example roles: Superuser, Admin, Analyst, Viewer
    switch (groupName) {
        case 'Superuser':
            return [
                { action: 'manage', subject: 'all' },
                { action: "manage", subject: "Admin Dashboard"},
                { action: "manage", subject: "CopyReport"}
            ];
  
        case 'Admin':
            return [
                { action: "manage", subject: "Auth"},
                { action: "manage", subject: "Workspace"},
                { action: "manage", subject: "Dashboard"},
                { action: "manage", subject: "Model"},
                { action: "manage", subject: "Company"},
                { action: "manage", subject: "DataConnector"},
                { action: "manage", subject: "Report"},
                { action: "manage", subject: "Scenarios"},
                { action: "manage", subject: "Support"},
                { action: "manage", subject: "Workflow"},
                { action: "manage", subject: "Data"},
                { action: "manage", subject: "Allocations"},
                { action: "manage", subject: "Calculations"},
                { action: "manage", subject: "Users"},
                { action: "manage", subject: "License"},
                { action: "manage", subject: "CopyReport"}
            ];
  
        case 'Builder':
            return [
                { action: "manage", subject: "Auth"},
                { action: "manage", subject: "Workspace"},
                { action: "manage", subject: "Dashboard"},
                { action: "read", subject: "Model"},
                { action: "manage", subject: "Company"},
                { action: "manage", subject: "DataConnector"},
                { action: "manage", subject: "Report"},
                { action: "read", subject: "Scenarios"},
                { action: "manage", subject: "Support"},
                { action: "manage", subject: "Workflow"},
                { action: "manage", subject: "Data"},
                { action: "manage", subject: "Allocations"},
                { action: "manage", subject: "Calculations"},
                { action: "read", subject: "CopyReport"}
            ];
    
        default: // Viewer
            return [
                { action: "manage", subject: "Auth"},
                { action: "manage", subject: "Workspace"},
                { action: "manage", subject: "Dashboard"},
                { action: "read", subject: "Model"},
                { action: "create", subject: "Workflow"},
                { action: "read", subject: "Scenarios"},
                { action: "manage", subject: "Report"},
                { action: "manage", subject: "Support"},
                { action: "read", subject: "Calculations"},
                { action: "read", subject: "CopyReport"}
            ];
    }
  }